<template>
  <div id="app"> 
    <!-- <scale-box :width="1920" :height="1080" bgc="transparent" :delay="100"> -->
      <Header v-show="$route.meta.show" :token="token"></Header>
      <router-view></router-view>
      <Footer v-show="$route.meta.show"></Footer>
    <!-- </scale-box> -->
      <div class="postionNav" v-show="path != '/login'">
        <div class="nav-top">
          <div @click="HandleSession">
            <img src="./assets/kef.png" alt="">
            <p>在线客服</p>
          </div>
          <div @mouseenter="HandleEnter" @mouseleave="HandleLeave">
            <img src="./assets/phone.png" alt="">
            <p>手机端</p>
          </div>
          <div @click="handleFu">
            <img src="./assets/funeng.png" alt="">
            <p>赋能</p>
          </div>
          <div @click="handleCart">
            <img src="./assets/guowuc.png" alt="">
            <p>购物车</p>
          </div>
          <div v-if="IsHeader" v-show="false">
            <img src="./assets/liulanjil.png" alt="">
            <p>浏览历史</p>
          </div>
        </div>
        <div class="nav-top nav-bottom">
          <div @click="returnTop">
            <img src="./assets/dingbu.png" alt="">
            <p>顶部</p>
          </div>
        </div>
      </div>

      <div class="phoneHover" v-show="phoneHover">
        <!-- <img src="./assets/wxchat.jpg" alt=""> -->
        <div id="qrcodeUrl"></div>
        <p>手机APP</p>
      </div>
  </div>
</template>

<script>

// import ScaleBox from "vue2-scale-box";
import Header from "./pages/header/index.vue"
import Footer from "./pages/footer/index.vue"
import QRCode from 'qrcodejs2'
// import devPixelRatio from "@/utils/devicePixelRatio.js";

export default {
  name: 'App',
  
  data(){
    return{
      IsHeader: false,
      phoneHover: false,
      token: '',
      path:''
    }
  },

  components: {
    // ScaleBox
    Header,
    Footer
  },
  methods:{
    
    // reload(){
    //     this.isRouterAlive = false;
    //     this.$nextTick(function () {
    //       this.isRouterAlive = true
    //     });
    // },
    HandleEnter(){
      this.phoneHover = true
    },
    HandleLeave(){
      this.phoneHover = false
    },
    returnTop(){
      app.scrollIntoView()
    },
    handleFu(){
      this.$router.push('/funeng')
    },
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },
    HandleSession(){
      this.$router.push({
        path: '/session',
      })
    },
    handleCart(){
      this.$router.push({
          path: '/cart',
        })
    },
    getQrcode(){

      document.getElementById( 'qrcodeUrl' ).innerHTML =  '' ;
      
      var qrcode = new QRCode('qrcodeUrl', {
          text: 'http://h5.qlg360.com',
          width: 100,
          height: 100,
          colorDark : '#000000',
          colorLight : '#ffffff',
          correctLevel : QRCode.CorrectLevel.H
      });
    
    }
    
  },
  mounted(){
    // var test = window.location.pathname;
    // if(test == '/login' || test == '/forgetPassword' || test == '/register'){
    //   this.IsHeader = false
    // }else{
    //   this.IsHeader = true
    // }
    //     this.path = this.$route.path
    // console.log("当前路由："+this.path);
      this.getQrcode()
      var ww = document.documentElement.clientWidth
      
      if (this._isMobile()) {
        // alert("手机端");
        window.location.href = 'http://h5.qlg360.com'
      } else {
        // alert("pc端");
      }
     
      this.$router.beforeEach((to, from, next) => {
        console.log('上一个路由的路径', from.path)
        if(from.path == '/login'){
          this.IsHeader = true
          this.token = localStorage.getItem('token')
        }
        sessionStorage.setItem('path',from.path)
        next()
      })
   
  },
  created() {
    if(localStorage.getItem('token')){
      this.IsHeader = true
    }else{
      this.IsHeader = false
    }
  
    // new devPixelRatio().init(); // 初始化页面比例
  },
  
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  /* -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; */
  background: #eff2f5;
  font-size: 20px;
  padding: 0;margin: 0;
  /* text-align: center; */
}
@media screen and (min-width: 541px) {
    
  #app {
    max-width: 100%;
    min-width: 1200px;
  }
}
ul li {
    list-style-type: none;
    list-style: none;
}
li{
    list-style: none;
}
a{
  text-decoration: none;
}
p{
  -webkit-margin-before:0;
  -webkit-margin-after:0;
}

</style>

<style scoped lang="scss">
#app{
  .postionNav{
    width: 68px;
    position: fixed;
    right: 10px;
    bottom: 200px;
    .nav-top{
      background-color: #fff;
      width: 100%;
      
      div{
        border-bottom: 1px solid #e6e6e6;
        padding: 5px 0px;
        text-align: center;
        cursor: pointer;
        img{
          width: 30px;height: 30px;
        }
        p{
          font-size: 12px;
          color: #333;
        }
      }
      div:hover{
        box-shadow: 0 2px 4px rgba(0, 0, 0, .2);
      }
    }
    .nav-bottom{
      margin-top: 35px;
    }
  }

  .phoneHover{
    position: fixed;
    padding: 10px 10px;
    right: 88px;
    // bottom: 397px;
    bottom: 338px;
    text-align: center;
    background-color: #fff;
    z-index: 999;
    div{
      width: 100px;height: 100px;
    }
    p{
      font-size: 14px;
      margin-top: 8px;
      color: #8c8c8c;
    }
  }
}
</style>
